import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RandomGeneratorService } from '../helper/random-generator.service';
import { SiteService } from './site.service';

@Injectable({
    providedIn: 'root',
})
export class ConfigurationService {

    private configSave: any = null;

    constructor(private myHttpClient: HttpClient,
                private mySiteService: SiteService,
                private myTranslateService: TranslateService,
                private myRandomGeneratorService: RandomGeneratorService,
    ) {
    }

    /**
     * Gibt die gecachte config zurück, falls keine vorhanden ist, wird sie neu geholt udn dann zurück gegeben.
     */
    public async getConfig(): Promise<any> {
        if (this.configSave != null) {
            return this.configSave;
        } else {
            return this.myHttpClient.get(this.getURL()).toPromise()
                .then((res: any) => {
                    this.configSave = res.config;
                    return res.config;
                })
                .catch(() => null);
        }
    }

    public getLoadedConfig(): any {
        return this.configSave;
    }

    /**
     * Loads the config
     */
    public loadConfig(): Promise<any> {
        if (this.getURL()) {
            return this.myHttpClient.get(`${this.getURL()}?v=${this.myRandomGeneratorService.generateAlphaNumberId(10)}`)
                .toPromise()
                .then((res: any) => {
                    this.configSave = res.config;
                    return res.config;
                }).catch(() => {
                    console.error(`${this.getURL()} not found!`);
                });
        } else {
            return this.myHttpClient.get(`assets/config/app-config.json?v=${this.myRandomGeneratorService.generateAlphaNumberId(10)}`)
                .toPromise()
                .then((res: any) => {
                    this.configSave = res.config;
                    return res.config;
                }).catch(() => {
                    console.error('assets/config/app-config.json not found!');
                });
        }
    }

    public getLanguage(): any {
        return this.myTranslateService.instant('sla-core.commons.locale-culture');
    }

    protected getURL(): string {
        return this.mySiteService.getConfigKey('config');
    }
}
